import OrganizationForm from '../../components/OrganizationForm/OrganizationForm';
import { CREATE_ORGANIZATION } from '../../constants';

function OrganizationCreation() {
  return <OrganizationForm type={CREATE_ORGANIZATION} />;
}

export default OrganizationCreation;
